// src/pages/Tarifs/data/pricingCatalog.js

import {
  FaChalkboardTeacher,
  FaClipboardCheck,
  FaCrown,
  FaLandmark,
  FaLayerGroup,
  FaMapMarkedAlt,
  FaRegBuilding,
  FaShieldAlt,
  FaTrophy,
} from "react-icons/fa";

// Déplace ici l’intégralité de ton tableau APPS actuel.
export const PRICING_APPLICATIONS = [
  {
    id: "monappliclub_standard",
    category: "clubs",
    name: "MonAppliClub Standard",
    short: "La solution complète pour gérer un club sportif.",
    logo: "https://www.monappliclub.com/logo_monappliclub2026_512.png",
    icon: FaCrown,
    badge: "Le plus complet",
    audience: "Clubs sportifs qui veulent une application complète",
    priceText: "360 €",
    suffix: "/an",
    note: "Tout compris",
    highlight: true,
    theme: {
      bar: "bg-orange-500",
      icon: "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
      badge:
        "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
    },
    features: [
      "Application complète de gestion de club",
      "Site internet du club inclus",
      "Inscriptions, adhérents, groupes, paiements",
      "Actualités, événements, galerie, boutique",
      "Hébergement, serveur, base de données et domaine inclus",
      "Support technique et accompagnement inclus",
    ],
  },
  {
    id: "monappliclub_light",
    category: "clubs",
    name: "MonAppliClub Light",
    short: "Une version plus simple pour les petits budgets.",
    logo: "https://api.monappliclub-demo-light.com/uploads/settings/image-1779038946178-618143934.png",
    icon: FaLayerGroup,
    badge: "Petit budget",
    audience: "Petits clubs qui veulent une présence web simple",
    priceText: "200 €",
    suffix: "/an",
    note: "Tarif unique",
    theme: {
      bar: "bg-amber-500",
      icon: "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300",
      badge:
        "bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300",
    },
    features: [
      "Version allégée de MonAppliClub",
      "Présentation du club",
      "Actualités, événements et informations utiles",
      "Administration simple",
      "Idéal pour démarrer avec un budget maîtrisé",
    ],
  },
  {
    id: "monappliag",
    category: "clubs",
    name: "MonAppliAG",
    short: "Application dédiée aux assemblées générales et votes en ligne.",
    logo: "https://www.monappliag.com/img/logos/logo_monappliag_2026.png",
    icon: FaChalkboardTeacher,
    badge: "Assemblée générale",
    audience: "Président·e·s et responsables d’associations",
    note: "Abonnement annuel",
    theme: {
      bar: "bg-orange-600",
      icon: "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
      badge:
        "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
    },
    plans: [
      {
        name: "Moins de 200 adhérents",
        priceText: "25 €",
        suffix: "/an",
        description: "Pour les associations de moins de 200 membres.",
      },
      {
        name: "200 adhérents et plus",
        priceText: "50 €",
        suffix: "/an",
        description: "Pour les associations plus importantes.",
        highlight: true,
      },
    ],
    features: [
      "Centraliser les convocations, ordres du jour, rapports et pièces jointes",
      "Préparer les bilans financiers, budgets prévisionnels et graphiques",
      "Gérer les participants, les membres du bureau et les accréditations",
      "Effectuer l’émargement manuellement ou grâce à un QR code",
      "Enregistrer les pouvoirs et suivre le quorum en temps réel",
      "Présenter les documents directement aux participants pendant la séance",
      "Lancer des votes en direct et obtenir automatiquement les résultats",
      "Conserver les procès-verbaux, documents et décisions classés par saison."
    ],
  },
  {
    id: "monapplimairie",
    category: "collectivites",
    name: "MonAppliMairie",
    short: "Un site communal moderne, administrable et accessible.",
    logo: "https://api.monapplimairie.com/uploads/media/images/2026/06/logo-monapplimairie_1780748151121_jgku4h.webp",
    icon: FaLandmark,
    badge: "Commune",
    audience: "Mairies qui veulent un site moderne et simple à gérer",
    priceText: "300 €",
    suffix: "/an",
    note: "Tarif unique pour les mairies",
    theme: {
      bar: "bg-sky-500",
      icon: "bg-sky-50 text-sky-700 dark:bg-sky-500/10 dark:text-sky-300",
      badge:
        "bg-sky-50 text-sky-700 dark:bg-sky-500/10 dark:text-sky-300",
    },
    features: [
      "Site internet communal moderne",
      "Actualités, agenda, projets et services municipaux",
      "Pages personnalisées",
      "Associations, commerces, élus, publications",
      "Administration facile par les équipes de la mairie",
      "Tarif unique pour les mairies",
    ],
  },
  {
    id: "monappliasso",
    category: "collectivites",
    name: "MonAppliAsso",
    short: "Un portail clair pour valoriser les associations d’une commune.",
    logo: "/images/logo_monappliasso_512.png",
    icon: FaRegBuilding,
    badge: "Associations",
    audience: "Communes qui veulent présenter leurs associations",
    priceText: "200 €",
    suffix: "/an",
    note: "Tarif unique",
    theme: {
      bar: "bg-violet-500",
      icon: "bg-violet-50 text-violet-700 dark:bg-violet-500/10 dark:text-violet-300",
      badge:
        "bg-violet-50 text-violet-700 dark:bg-violet-500/10 dark:text-violet-300",
    },
    features: [
      "Annuaire des associations de la commune",
      "Fiches associations détaillées",
      "Mise à jour possible par les associations",
      "Interface simple pour la mairie",
      "Valorisation de la vie associative locale",
    ],
  },
  {
    id: "monapplitournoi",
    category: "judo",
    name: "MonAppliTournoi",
    short: "Gestion de compétitions, tournois et tableaux de score.",
    logo: "https://www.scoreboard-judo-club.fr/logo_monapplitournoi_512.png",
    icon: FaTrophy,
    badge: "Compétitions",
    audience: "Clubs et organisateurs de compétitions",
    note: "Tarif inchangé",
    theme: {
      bar: "bg-emerald-500",
      icon: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
      badge:
        "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300",
    },
    plans: [
      {
        name: "Compétition à l’unité",
        priceText: "25 €",
        suffix: "/compétition",
        description: "Pour organiser une compétition ponctuelle.",
      },
      {
        name: "Abonnement annuel",
        priceText: "50 €",
        suffix: "/an",
        description: "Pour organiser plusieurs compétitions dans l’année.",
        highlight: true,
      },
    ],
    features: [
      "Création de compétitions",
      "Gestion des catégories et tableaux",
      "Résultats publics",
      "Tableaux de score sur écran",
      "Formation en visio possible",
    ],
  },
  {
    id: "judo-coach-pro",
    category: "judo",
    name: "Judo Coach Pro",
    short: "Outils pédagogiques, techniques, suivi des judokas et progression.",
    logo: "https://www.judo-coach-pro.com/img/logo_judocoach_pro_512.png",
    icon: FaChalkboardTeacher,
    badge: "Coach",
    audience: "Enseignants, coachs et clubs de judo",
    note: "Abonnement annuel",
    theme: {
      bar: "bg-orange-600",
      icon: "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
      badge:
        "bg-orange-50 text-orange-700 dark:bg-orange-500/10 dark:text-orange-300",
    },
    plans: [
      {
        name: "Moins de 100 adhérents",
        priceText: "20 €",
        suffix: "/an",
        description: "Pour les petits clubs ou sections judo.",
      },
      {
        name: "100 adhérents et plus",
        priceText: "30 €",
        suffix: "/an",
        description: "Pour les clubs plus importants.",
        highlight: true,
      },
    ],
    features: [
      "Techniques, UV2, kata, lexique et quizz",
      "Suivi des résultats, palmarès et passages de grades",
      "Événements et compétitions partagées",
      "Règlement, arbitrage et tableaux de score",
      "Outils pédagogiques pour les enseignants",
    ],
  },
  {
    id: "judo-presence-pro",
    category: "judo",
    name: "Judo Présence Pro",
    short: "Pointage des présences et suivi des adhérents.",
    logo: "https://www.judo-presence-pro.com/logo_presence-pro3.png",
    icon: FaClipboardCheck,
    badge: "Présences",
    audience: "Clubs qui veulent suivre les présences facilement",
    note: "Abonnement annuel",
    theme: {
      bar: "bg-cyan-500",
      icon: "bg-cyan-50 text-cyan-700 dark:bg-cyan-500/10 dark:text-cyan-300",
      badge:
        "bg-cyan-50 text-cyan-700 dark:bg-cyan-500/10 dark:text-cyan-300",
    },
    plans: [
      {
        name: "Moins de 100 adhérents",
        priceText: "20 €",
        suffix: "/an",
        description: "Pour les petits clubs.",
      },
      {
        name: "100 adhérents et plus",
        priceText: "30 €",
        suffix: "/an",
        description: "Pour les clubs avec davantage d’adhérents.",
        highlight: true,
      },
    ],
    features: [
      "Pointage rapide des présences",
      "Informations adhérents accessibles facilement",
      "Statistiques de présence",
      "Exports de données",
      "Accès bureau et enseignants",
    ],
  },
  {
    id: "monapplicomite",
    category: "federal",
    name: "MonAppliComité",
    short: "Une application complète pour les comités départementaux.",
    logo: "https://api.judogironde.fr/uploads/photos_settings/1/logo_comite-2026-03-06T123711458Z-400.webp",
    icon: FaMapMarkedAlt,
    badge: "Comité",
    audience: "Comités départementaux",
    priceText: "360 €",
    suffix: "/an",
    note: "Tout compris",
    theme: {
      bar: "bg-indigo-500",
      icon: "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",
      badge:
        "bg-indigo-50 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-300",
    },
    features: [
      "Site et application du comité",
      "Calendrier interactif des compétitions",
      "Convocations des officiels",
      "Fiches de frais",
      "Articles, résultats et galerie photos",
      "Hébergement, serveur, base de données et domaine inclus",
    ],
  },
  {
    id: "monappliligue",
    category: "federal",
    name: "MonAppliLigue",
    short: "Une application complète pour les ligues régionales.",
    logo: "https://www.liguejudona.com/logo_NA_fondblanc.jpg",
    icon: FaShieldAlt,
    badge: "Ligue",
    audience: "Ligues régionales",
    priceText: "360 €",
    suffix: "/an",
    note: "Tout compris",
    theme: {
      bar: "bg-purple-500",
      icon: "bg-purple-50 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
      badge:
        "bg-purple-50 text-purple-700 dark:bg-purple-500/10 dark:text-purple-300",
    },
    features: [
      "Site et application de ligue",
      "Calendrier régional interactif",
      "Convocations des officiels",
      "Fiches de frais",
      "Articles, résultats, commissions et galerie photos",
      "Hébergement, serveur, base de données et domaine inclus",
    ],
  },
];

export const PRICING_CATEGORIES = [
  {
    id: "clubs",
    label: "Clubs sportifs",
    description: "Gestion complète, communication et présence en ligne.",
  },
  {
    id: "collectivites",
    label: "Mairies & associations",
    description: "Sites communaux et valorisation de la vie associative.",
  },
  {
    id: "judo",
    label: "Judo & compétitions",
    description: "Outils pédagogiques, présences et organisation sportive.",
  },
  {
    id: "federal",
    label: "Comités & ligues",
    description: "Plateformes dédiées aux instances territoriales.",
  },
];